"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BackButton;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function BackButton(_ref) {
  let {
    title = 'Back'
  } = _ref;
  const history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement(StyledBackButton, {
    onClick: () => history.goBack()
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u3008 ", title));
}
const StyledBackButton = (0, _styledComponents.default)(_Button.default).attrs({
  color: 'primary'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
BackButton.defaultProps = {
  title: 'Back'
};
BackButton.propTypes = {
  title: _propTypes.default.string
};